<template>
  <div class="home-page">
    <div class="ew-login-layout d-flex align-items-center justify-content-center vh-100">
      <div class="login-card shadow-lg rounded overflow-hidden d-flex flex-row bg-white w-100"
        style="max-width: 900px;">

        <!-- Formulario izquierdo -->
        <div class="login-form flex-fill p-5" style="flex: 0 0 55%;">
          <router-link to="/" class="d-block text-center mb-4">
            <img class="ew-login-logo mb-3" src="@/assets/images/sack/logo.png" alt="Logo SackEnvios">
          </router-link>

          <!-- Alerts -->
          <p v-if="recoveryResult === 'success'" class="alert alert-success">
            ¡Éxito! Verifica tu correo para configurar tu nueva contraseña.
          </p>
          <p v-if="recoveryResult === 'error'" class="alert alert-danger">
            ¡Error! El correo no existe.
          </p>

          <!-- Formulario -->
          <form @submit.prevent="passwordRecovery">
            <div class="form-group mb-4">
              <label>Correo electrónico <sup>*</sup></label>
              <input type="email" class="form-control" v-model="email" placeholder="correo@ejemplo.com" required>
            </div>

            <div class="text-right">
              <button type="submit" class="btn btn-primary btn-lg">Recuperar contraseña</button>
            </div>
          </form>
        </div>

        <!-- Lado derecho: patrón decorativo o imagen -->
        <div class="login-pattern flex-fill d-none d-md-block" style="flex: 0 0 45%;">
          <div class="h-100 w-100 bg-pattern"></div>
        </div>

      </div>
    </div>
    <!-- Footer global -->
    <AppFooter />
  </div>
</template>

<style scoped>
.ew-login-layout {
  background: #f5f7fa;
}

.login-card {
  max-width: 900px;
  width: 90%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.login-form {
  flex: 0 0 55%;
  padding: 3rem 2.5rem;
}

.login-pattern {
  flex: 0 0 45%;
  background: linear-gradient(135deg, #5B72A5, #6274A7);
}

.bg-pattern {
  height: 100%;
  width: 100%;
  /* opcional */
  background-size: cover;
  background-position: center;
}


.btn-lg {
  width: 100%;
}
</style>

<script>
import AppFooter from "@/components/AppFooter.vue";
import axios from 'axios'
import commons from '../commons'

export default {
  name: 'PasswordRecovery',
  data() {
    return {
      email: '',
      recoveryResult: 'none'
    }
  },
  components: {
    AppFooter
  },
  methods: {
    passwordRecovery() {
      axios
        .post(`${commons.apiURL}/api/v1/password-recovery`, {
          email: this.email
        })
        .then(response => {
          console.log(response)
          this.recoveryResult = 'success'
        })
        .catch(error => {
          this.recoveryResult = 'error'
          console.error(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PasswordRecovery.vue